import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const StorefrontPage = lazy(() => import('./pages/StorefrontPage'));

export const StorefrontRoutes: RouteObject = {
  path: 'storefront',
  children: [
    { path: '', element: <StorefrontPage />, handle: { crumb: 'Storefront & Checkout' } },
  ],
};
